import Vue from 'vue';

Vue.directive('savedStatus', {
    /**
     * @param {HTMLElement} el
     */
    update: function (el) {
        const span = el.querySelector('span');
        if (span) {
            span.classList.remove('action-message--pop-in');
            span.classList.add('action-message--pop-in');
            setTimeout(() => span.classList.remove('action-message--pop-in'), 2000);
        }
    }
})
